import { Flex, Tooltip } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { EnergyRevenuesCellCheckStateResponse } from "../../../RevenueMonitoring.types";
import { getDiff } from "../../utils/getDiff";

export function getDiffColumn(): MRT_ColumnDef<EnergyRevenuesCellCheckStateResponse> {
  return {
    id: "diff",
    header: "±",
    accessorFn: (row) =>
      typeof row.user_provided_amount === "number"
        ? getDiff({
            originalValue: row.calculated_amount,
            targetValue: row.user_provided_amount
          }).diffPercent
        : null,
    enableEditing: false,
    size: 5,
    Cell: ({ row }) => {
      const userProvidedAmount = row.original.user_provided_amount;

      if (typeof userProvidedAmount !== "number") {
        return null;
      }

      const { diffPercent, tooltipLabel } = getDiff({
        originalValue: row.original.calculated_amount,
        targetValue: userProvidedAmount
      });

      return (
        <Flex align="center" justify={"flex-end"}>
          <Tooltip label={tooltipLabel}>
            <span>{`${diffPercent}%`}</span>
          </Tooltip>
        </Flex>
      );
    },
    mantineTableHeadCellProps: {
      className: "th-rightaligned"
    },
    filterVariant: "range"
  };
}
